import { ref, computed } from 'vue'
import { AppLayoutMode } from '@/models/AppLayoutMode'

// shared singleton state (default to FitToContent)
const layoutMode = ref<AppLayoutMode>(AppLayoutMode.FitToContent)

export function useAppLayoutMode() {
  const setLayoutMode = (mode: AppLayoutMode) => {
    layoutMode.value = mode
  }
  const setFitToBrowser = () => (layoutMode.value = AppLayoutMode.FitToBrowser)
  const setFitToContent = () => (layoutMode.value = AppLayoutMode.FitToContent)
  const toggleLayoutMode = () =>
    (layoutMode.value =
      layoutMode.value === AppLayoutMode.FitToBrowser
        ? AppLayoutMode.FitToContent
        : AppLayoutMode.FitToBrowser)

  const isFitToBrowser = computed(() => layoutMode.value === AppLayoutMode.FitToBrowser)

  return {
    layoutMode,
    setLayoutMode,
    setFitToBrowser,
    setFitToContent,
    toggleLayoutMode,
    isFitToBrowser
  }
}
